"use strict";
import React from "react";
import { useTranslation } from "react-i18next";
export const Translation = (props) => {
  const { t } = useTranslation();
  const { children, className = "" } = props;
  return /* @__PURE__ */ React.createElement("span", { className }, t(children));
};
